import * as React from 'react';
import { Card, Button, ButtonGroup, Col, Form, InputGroup, Row } from 'react-bootstrap';
import Icon from '@mdi/react';
import { mdiCheck, mdiLeaf, mdiSnowflake, mdiWeatherSunny } from '@mdi/js';

export const ClimateTab: React.FC = (): React.ReactElement => {
  const styles = {
    row: {
      margin: '15px',
    },
  };
  return (
    <Card style={styles.row}>
      <Card.Header as="h5">Kliima pult</Card.Header>
      <Card.Body>
        <Row>
          <Col xs={12} md={4}>
            <ButtonGroup className="d-flex" aria-label="iSave">
              <Button variant="outline-primary" className="col-2" disabled={true}>
                <Icon path={mdiCheck} size="1.5em" />
              </Button>
              <Button variant="outline-primary" active={true}>
                <Icon path={mdiLeaf} size="1.5em" />
                i-save
              </Button>
            </ButtonGroup>
          </Col>
        </Row>
        <br />
        <Row>
          <Col xs={12} md={4}>
            <ButtonGroup className="d-flex" aria-label="Mode">
              <Button variant="outline-primary">
                <Icon path={mdiWeatherSunny} size="1.5em" />
              </Button>
              <Button variant="outline-primary">
                <Icon path={mdiSnowflake} size="1.5em" />
              </Button>
            </ButtonGroup>
          </Col>
        </Row>
        <br />
        <Row>
          <Col xs={12} md={4}>
            <InputGroup>
              <Form.Control
                type="number"
                inputMode="numeric"
                min={16}
                max={30}
                step={1}
                aria-label="Temperature"
                onChange={(e) => console.log(`value: ${e.target.value}`)}
              />
              <InputGroup.Text>°C</InputGroup.Text>
            </InputGroup>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};
